import NextImage from '@/features/Image';
import CartQuantity from '@/features/cart/components/CartQuantity';
import { pushToDataLayer, toGa4CartItem } from '@/features/gtm/gtmUtils';
import { deleteCartItem } from '@/lib/redux/features/cart';
import { useAppDispatch } from '@/lib/redux/hooks';
import Link from 'next/link';
function DrawerItem({ product }: any) {
  const dispatch = useAppDispatch();

  const removeProduct = () => {
    dispatch(deleteCartItem(product.id));
    pushToDataLayer('remove_from_cart', {
      ecommerce: {
        value: Number(product?.price) * Number(product?.quantity),
        currency: 'BDT',
        items: [
          toGa4CartItem(product),
        ],
      },
    });
  };
  return (
    <div className="product">
      <div className="product-details">
        <h6 className="product-titled fs-small">
          <Link href={`/product/${product?.slug}`}>
            {product?.product_name}
          </Link>
        </h6>

        <div className="d-flex flex-column gap-1">
          <CartQuantity
            product={product}
            size="fs-small"
            className="d-flex flex-row"
          />
          <span className="cart-product-info">
            <span className="cart-product-qty">{product?.quantity}</span> ×{' '}
            {product.currency_symbol}
            {Number(product.price).toFixed(2)}
          </span>
        </div>
      </div>
      <figure className="product-image-container">
        <NextImage
          src={product?.product_thumbnail_image}
          alt="product"
          width={80}
          height={80}
        />
        <span
          onClick={removeProduct}
          title="Remove Product"
          className="btn-remove"
        >
          ×
        </span>
      </figure>
    </div>
  );
}

export default DrawerItem;
